<div class="flex flex-column px-8 py-5 gap-4">
  <i class="pi pi-user-plus m-auto" style="font-size: 2.5rem" aria-label="alert clock icon" role="img"></i>
</div>
<p class="text-center text-xl font-semibold">
  U.S. Agent is already associated
</p>
<p class="text-center">
  A U.S. Agent is already associated with the aircraft details you entered
</p>
<div class="flex justify-content-center gap-2">
  <button pButton label="Keep Existing U.S. Agent" class="primary default" (click)="closeModal(false)">
    <span pButtonLabel>Keep Existing U.S. Agent</span>
  </button>
  <button pButton label="Designate New U.S. Agent" class="primary default" (click)="closeModal(true)">
    <span pButtonLabel>Designate New U.S. Agent</span>
  </button>
  <button type="button" label="Cancel" class="secondary default" (click)="closeModal()">Cancel</button>
</div>
